<div class="flex flex-wrap">
  <div class="relative w-full xl:w-5/12 authBackground">
    <app-carousel></app-carousel>
  </div>
  <div class="relative w-full xl:w-7/12">
    <div class="login-card">
      <div class="login-main">
        <form action="#">
          <app-stepper>
            <!-- STEP 1 - DETAILS / CONTACT -->
            <cdk-step label="Enter">
              <div class="setup-content mt-12" id="step-1">
                @if (!showContactStep()) {
                <app-register-details-step (detailsSubmit)="onDetailsSubmitted($event)"></app-register-details-step>
                } @else {
                <app-register-contact-step
                  [portal]="portal"
                  [entityName]="detailsInfo().entityName"
                  [termsAndConditionsUrl]="termsAndConditionsUrl()"
                  (contactSubmit)="onContactSubmitted($event)"
                  (back)="goBackToDetails()"
                ></app-register-contact-step>
                }
              </div>
            </cdk-step>

            <!-- STEP 2 - OTP -->
            <cdk-step label="Verify">
              @if(channelTypeValue()) {
              <app-otp
                [channelValue]="channelTypeValue()"
                [channelType]="channelType"
                [webBackend]="false"
                (goBack)="goBack()"
                (verified)="onVerified($event)"
              ></app-otp>
              }
            </cdk-step>

            <!-- STEP 3 - PIN -->
            @if (loginType === 'pin') {
            <cdk-step label="Register">
              <app-register-pin-step (pinSubmit)="onCredentialSubmit($event)" (back)="goBack()"></app-register-pin-step>
            </cdk-step>
            } @else {
            <!-- STEP 3 - PASSWORD -->
            <cdk-step label="Register">
              <app-register-password-step
                (passwordSubmit)="onCredentialSubmit($event)"
                (back)="goBack()"
              ></app-register-password-step>
            </cdk-step>
            }
          </app-stepper>
        </form>
      </div>
    </div>
  </div>
</div>
